import { render, staticRenderFns } from "./HelpDomains.vue?vue&type=template&id=6184369a&scoped=true&"
import script from "./HelpDomains.vue?vue&type=script&lang=ts&"
export * from "./HelpDomains.vue?vue&type=script&lang=ts&"
import style0 from "./HelpDomains.vue?vue&type=style&index=0&id=6184369a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6184369a",
  null
  
)

export default component.exports